module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10205.e71476ea.jpg";